import { Button, TextField } from '@mui/material';
import React, { useEffect, useState } from 'react'
import swal from 'sweetalert';
import axios from 'axios';
import { base_url, postHeader } from '../Helpers/request';
import { useHistory } from "react-router-dom";
import Loader from './Loader';
import { Col, Row, Modal, Form, Image } from 'react-bootstrap';
import { cartlengthvalue } from '../Reducer/cartReducer';
import { useDispatch } from 'react-redux';
import CardsImg from '../../src/Assets/images/cardImage/cards-img.png'

export const Authorize = ({ data }) => {
    const [loader, setLoader] = useState(false);
    const [open, setOpen] = useState(true);
    const [cardNumber, setCardNumber] = useState('');
    const [card_expiry_mm, setCard_expiry_mm] = useState('');
    const [card_expiry_yy, setCard_expiry_yy] = useState('');
    const [cardcvv, setCardcvv] = useState('');
    const history = useHistory();
    const dispatch = useDispatch()

    const collect = (e) => {
        if(cardNumber === "" || cardcvv === "" || card_expiry_mm === "" || card_expiry_yy === ""){
            swal("Please fill out the card details", "", "error");
        }else{
            e.preventDefault();
            setLoader(true);
            const res = {
                order_id: data.order_id,
                card_number: cardNumber,
                card_exp_year: card_expiry_yy,
                card_exp_month: card_expiry_mm,
                card_cvc: cardcvv,
            }
            axios.post(base_url + '/Order/authorize', res, {
                headers: postHeader
            })
                .then(response => {
                    if (response.data.status == 1) {
                        setLoader(false)
                        history.push(`/ordersuccess/${response.data.data.order_id}/${response.data.data.order_no}/${response.data.data.txn_id}`)
                        dispatch(cartlengthvalue(0))
                        sessionStorage.removeItem("bw-checkoutdata")
                    } else {
                        setLoader(false)
                        return swal(response.data.message, "", "error");
                    }
                })
                .catch(err => {
                    console.log(err)
                })
        }
        
    }
    return (
        <>
            {/* <Modal show={open} onHide={() => setOpen(false)}> */}
            <div className="rcs_appointment_input rcs_login p-0">
                <Form>
                    <Row>
                        <Col xs={12}>
                            <div class="form-group rcs_card_number_input position-relative">
                                <label for="html">Card number</label>
                                <span className='position-relative d-block'>
                                    <input autocomplete="off"
                                        className="form-control shadow-none"
                                        maxlength="16"
                                        pattern="[0-9]*"
                                        value={cardNumber}
                                        onChange={(e) => setCardNumber(e.target.value)}
                                        inputmode="numerical"
                                        placeholder="1234 1234 1234 1234"
                                        type="text"
                                        data-pattern-validate
                                        autoFocus
                                    />
                                        
                                    <Image src={CardsImg} alt="cards image"  />
                                </span>
                               
                            </div>

                        </Col>
                    </Row>
                    <Row>
                        <Col xs={12} sm={6} md={6} className="mb-3">
                            <label for="html">Expiration</label>
                            <div class="rcs_card_input_wrapper card-expiration-date position-relative d-flex justify-content-center">

                                <input autocomplete="off"
                                    className="exp form-control shadow-none border-right-0"
                                    id="month"
                                    maxlength="2"
                                    pattern="[0-9]*"
                                    value={card_expiry_mm}
                                    onChange={(e) => setCard_expiry_mm(e.target.value)}
                                    inputmode="numerical"
                                    placeholder="MM"
                                    type="text"
                                    data-pattern-validate />
                                <input autocomplete="off"
                                className="exp form-control shadow-none border-left-0"
                                id="year"
                                maxlength="4"
                                pattern="[0-9]*"
                                value={card_expiry_yy}
                                onChange={(e) => setCard_expiry_yy(e.target.value)}
                                inputmode="numerical"
                                placeholder="YYYY"
                                type="text"
                                data-pattern-validate />
                            </div>
                        </Col>
                        <Col xs={12} sm={6} md={6} className="mb-3">

                            <div class="form-group rcs_card_number_input">
                                <label for="html">CVC</label>
                                <input autocomplete="off"
                                    className="form-control shadow-none"
                                   
                                    maxlength="3"
                                    pattern="[0-9]*"
                                    value={cardcvv}
                                    onChange={(e) => setCardcvv(e.target.value)}
                                    inputmode="numerical"
                                    placeholder="CVC"
                                    type="text"
                                    data-pattern-validate />
                            </div>

                        </Col>

                    </Row>
                    <Row>
                        <Col sm={12} md={6} lg={6}>
                            <Button className="rcs_fill_button" onClick = {collect}>
                                CONTINUE
                            </Button>
                        </Col>
                    </Row>
                </Form>
            </div>
        </>
    )
}


